<div class="hero">
  <div class="copy">
    <img src="assets/images/logo/logo-marz-branca.png" width="150" height="51" alt="Agency MARZ" class="logo">
    <p class="eyebrow">AGENCY MARZ CADASTRO ATLETAS MMA PROFISSIONAL</p>
    <h1>Quer lutar nos melhores eventos de MMA filiados a Agency MARZ com nível UFC?</h1>
    <div class="events">
      <img class="mr-3" src="assets/images/events/bfc.png" width="100" height="50" alt="BFC Brothers Fight Champion" class="logo">
      <img src="assets/images/events/victory-2.png" width="150" height="29" alt="Vicotry 2" class="logo">
    </div>
    <p class="lede">Faça seu cadastro abaixo, complete todas as informações e fique pronto para lutar em algum dos nossos eventos em breve!</p>
    <div class="highlights">
      <div>✔️ Cadastro rápido</div>
      <div>✔️ Maiores chances de lutas</div>
      <div>✔️ Links Tapology, Sherdog e Instagram</div>
    </div>
  </div>

  <div class="form-card">
    <!-- Success Screen -->
    <div *ngIf="showSuccessScreen" class="success-screen">
      <div class="success-icon">✓</div>
      <h2>Parabéns, cadastro efetuado com sucesso!</h2>
      <p>{{ successMessage }}</p>
      <p class="success-subtitle">Em breve entraremos em contato com você.</p>
    </div>

    <!-- Form -->
    <div *ngIf="!showSuccessScreen">
      <div class="steps">
        <div class="step" *ngFor="let step of steps; let idx = index" [class.active]="idx === currentStep"
          [class.done]="idx < currentStep">
          <span>{{ idx + 1 }}</span>
          <p>{{ step }}</p>
        </div>
      </div>

      <form [formGroup]="form" (ngSubmit)="submit()">
      <div *ngIf="currentStep === 0" class="grid">
        <label class="full-row">
          <span>Email</span>
          <input formControlName="email" type="email" placeholder="voce@email.com" />
          <small *ngIf="form.get('email')?.touched && form.get('email')?.invalid">
            Informe um email válido
          </small>
        </label>
        <p *ngIf="athleteExists" class="feedback info full-row">
          Este e-mail já está cadastrado. Se precisar atualizar seus dados, entre em contato com a Agência.
        </p>
      </div>

      <div *ngIf="currentStep === 1" class="grid">
        <label>
          <span>Nome completo</span>
          <input formControlName="full_name" type="text" placeholder="Seu nome" />
          <small *ngIf="form.get('full_name')?.touched && form.get('full_name')?.invalid">Campo obrigatório</small>
        </label>
        <label>
          <span>Data de nascimento</span>
          <input formControlName="birth_date" type="date" />
          <small *ngIf="form.get('birth_date')?.touched && form.get('birth_date')?.invalid">Campo obrigatório</small>
        </label>
        <label class="full-row">
          <span>Idade</span>
          <div class="readonly">{{ age !== null ? age + ' anos' : 'Informe a data de nascimento' }}</div>
        </label>
        <label class="full-row">
          <span>País</span>
          <select formControlName="country" (change)="onCountryChange()">
            <option *ngFor="let country of countries" [value]="country">{{ country }}</option>
          </select>
        </label>
        <ng-container *ngIf="isBrazil; else stateText">
          <label>
            <span>Estado</span>
            <select formControlName="state" (change)="onStateChange()">
              <option value="">Selecione</option>
              <option *ngFor="let uf of states" [value]="uf">{{ uf }}</option>
            </select>
            <small *ngIf="form.get('state')?.touched && form.get('state')?.invalid">
              Selecione o estado
            </small>
          </label>
        </ng-container>
        <ng-template #stateText>
          <label>
            <span>Estado / Província</span>
            <input formControlName="state" type="text" placeholder="Estado ou província" />
            <small *ngIf="form.get('state')?.touched && form.get('state')?.invalid">
              Informe o estado ou província
            </small>
          </label>
        </ng-template>
        <ng-container *ngIf="isBrazil; else cityText">
          <label>
            <span>Cidade</span>
            <select formControlName="city" [disabled]="!cities.length">
              <option value="">{{ cities.length ? 'Selecione' : 'Selecione o estado' }}</option>
              <option *ngFor="let c of cities" [value]="c">{{ c }}</option>
            </select>
            <small *ngIf="form.get('city')?.touched && form.get('city')?.invalid">
              Selecione a cidade
            </small>
          </label>
        </ng-container>
        <ng-template #cityText>
          <label>
            <span>Cidade</span>
            <input formControlName="city" type="text" placeholder="Cidade" />
            <small *ngIf="form.get('city')?.touched && form.get('city')?.invalid">
              Informe a cidade
            </small>
          </label>
        </ng-template>
      </div>

      <div *ngIf="currentStep === 2" class="grid">
        <label class="inline">
          <span>Profissional</span>
          <div class="chips">
            <button type="button" [class.active]="form.value.gender === 'M'" (click)="form.patchValue({ gender: 'M' })">
              Masculino
            </button>
            <button type="button" [class.active]="form.value.gender === 'F'" (click)="form.patchValue({ gender: 'F' })">
              Feminino
            </button>
          </div>
        </label>
        <label>
          <span>Nome de luta</span>
          <input formControlName="fight_name" type="text" placeholder="Ex: The Storm" />
          <small *ngIf="form.get('fight_name')?.touched && form.get('fight_name')?.invalid">Campo obrigatório</small>
        </label>
        <label class="full-row">
          <span>Categoria de peso</span>
          <select formControlName="weight_category">
            <option value="">Selecione</option>
            <option *ngFor="let w of weightClasses" [value]="w">{{ w }}</option>
          </select>
          <small *ngIf="form.get('weight_category')?.touched && form.get('weight_category')?.invalid">
            Selecione a categoria
          </small>
        </label>
        <label class="rookie-row">
          <div class="rookie-checkbox">
            <input id="rookie" type="checkbox" formControlName="is_rookie" (change)="onRookieChange()" />
            <label for="rookie">Estreante</label>
          </div>
        </label>
        <ng-container *ngIf="form.value.is_rookie; else proRecord">
          <label class="full-row">
            <p>MMA Amador</p>
          </label>
          <label>
            <span>Vitórias</span>
            <input formControlName="victories" type="number" min="0" />
          </label>
          <label>
            <span>Derrotas</span>
            <input formControlName="defeats" type="number" min="0" />
          </label>
          <label class="full-row">
            <span>Empates</span>
            <input formControlName="draws" type="number" min="0" />
          </label>
        </ng-container>
        <ng-template #proRecord>
          <label>
            <span>Vitórias</span>
            <input formControlName="victories" type="number" min="0" />
          </label>
          <label>
            <span>Derrotas</span>
            <input formControlName="defeats" type="number" min="0" />
          </label>
          <label class="full-row">
            <span>Empates</span>
            <input formControlName="draws" type="number" min="0" />
          </label>
        </ng-template>
        <label class="full-row">
          <span>Observações</span>
          <textarea formControlName="notes" maxlength="200" rows="4" placeholder="Observações sobre o atleta (opcional)"></textarea>
          <small class="char-counter">{{ (form.get('notes')?.value || '').length }}/200</small>
        </label>
      </div>

      <div *ngIf="currentStep === 3" class="grid">
        <ng-container *ngIf="!form.value.is_rookie">
          <label>
            <span>Tapology</span>
            <input formControlName="tapology_link" type="url" placeholder="https://www.tapology.com/..." />
            <small *ngIf="form.get('tapology_link')?.touched && form.get('tapology_link')?.invalid">
              Informe uma URL válida (https://)
            </small>
          </label>
          <label>
            <span>Sherdog</span>
            <input formControlName="sherdog_link" type="url" placeholder="https://www.sherdog.com/..." />
            <small *ngIf="form.get('sherdog_link')?.touched && form.get('sherdog_link')?.invalid">
              Informe uma URL válida (https://)
            </small>
          </label>
        </ng-container>
        <label>
          <span>Telefone</span>
          <input formControlName="phone" type="tel" placeholder="+55 (11) 99999-9999" />
          <small *ngIf="form.get('phone')?.touched && form.get('phone')?.invalid">
            Informe um telefone válido (apenas números, +, () e -)
          </small>
        </label>
        <label>
          <span>Instagram</span>
          <input formControlName="instagram" type="url" placeholder="https://instagram.com/..." />
          <small *ngIf="form.get('instagram')?.touched && form.get('instagram')?.invalid">
            Informe uma URL válida (https://)
          </small>
        </label>
      </div>

      <div class="actions">
        <button type="button" class="ghost" [disabled]="currentStep === 0" (click)="prevStep()">Voltar</button>
        <button *ngIf="currentStep < steps.length - 1" type="button" (click)="nextStep()" [disabled]="checkingEmail">
          {{ checkingEmail ? 'Verificando...' : 'Próximo' }}
        </button>
        <button *ngIf="currentStep === steps.length - 1" type="submit" [disabled]="saving">
          {{ saving ? 'Enviando...' : 'Enviar cadastro' }}
        </button>
      </div>

      <div class="feedback error" *ngIf="stepError">{{ stepError }}</div>
      <div class="feedback error" *ngIf="errorMessage && !showSuccessScreen">{{ errorMessage }}</div>
    </form>
    </div>
  </div>
</div>